export const FAQ_CATEGORIES_QUERY = '/api/faq/categories';

export const FAQ_QUERY = '/api/faq';

export const SEO_SSR_SEARCH_QUERY = '/seo/search';
